import styled from '@emotion/styled';
import { ISchoolClassInfo } from '@taleemabad/db';
import {
  IconText,
  List,
  shifts,
  Spacing,
  Tabs,
  Typography,
} from '@taleemabad/dsm/components';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';
import { FC } from 'react';

interface ReportCardAssignedClassesProps {
  activeTab?: number;
  handleTabChange: (value: number) => void;
  filteredClasses: ISchoolClassInfo[];
  handleGradeSelection: (item: ISchoolClassInfo) => void;
}

export const ReportCardAssignedClassesTemplate: FC<
  ReportCardAssignedClassesProps
> = ({
  activeTab = 1,
  handleTabChange,
  filteredClasses,
  handleGradeSelection,
}) => {
  return (
    <>
      <Spacing marginBottom="xxl">
        <Tabs
          variant="secondary"
          activeTabKey={activeTab}
          tabs={shifts}
          onChange={(value: number) => handleTabChange(value)}
        />
      </Spacing>
      <Spacing margin="xl" />
      <ListContainer>
        <ClassContainer>
          {filteredClasses.length > 0 && (
            <>
              <Typography variant="textTitleLarge">
                Select a class to see assessment results
              </Typography>
              <Spacing margin="md" />
              {filteredClasses.map((item) => (
                <List
                  key={item.id}
                  alignment="center"
                  heading={`${item.gradeLabel} - ${item.section} - ${item.subjectLabel}`}
                  onClick={() => handleGradeSelection(item)}
                  trailingIcon={{
                    direction: 'trailing',
                    source: 'keyboard_arrow_right',
                    name: 'keyboard_arrow_right',
                    type: 'icon',
                  }}
                />
              ))}
            </>
          )}
        </ClassContainer>
        <Spacing marginTop="xxxxl" marginBottom="xxl">
          <IconText
            text="Results for other grades are not added yet"
            textVariant="textBodyLargeLightPrimary"
            icon="error"
            iconColor="--md-sys-color-light-primary"
          />
        </Spacing>
      </ListContainer>
    </>
  );
};

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 300px);
  max-width: 524px;
  row-gap: var(--rk-spacing-xxxxxxxxxxxxxxxxxl);
  margin-top: var(--rk-spacing-xxxl);
  ${mq(BreakpointSizes.xs)} {
    justify-content: space-between;
    row-gap: var(--rk-spacing-md);
  }
`;

const ClassContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--rk-spacing-md);
`;
